import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';

const getShowCreateCombinedReport = async ({
    orgId,
}: {orgId: string}): Promise<boolean> => {
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.REPORTS.SHOW_CREATE_COMBINED_REPORT(orgId)}`,
    );
    return response.data;
};

export const useGetShowCreateCombinedReport = ({
    orgId,
} : {orgId: string}) => useQuery({
    queryKey: ['showCreateCombinedReport', orgId],
    queryFn: () => getShowCreateCombinedReport({
        orgId,
    }),
});
